<img
    style="
        cursor: pointer;
        width: 20px;
        height: 20px;
        padding: 0px;
        top: 130px;
        float: right;
        margin-right: -19px;
        margin-bottom: 4px;
    "
    (click)="closeDialog()"
    src="https://images.dailyobjects.com/icons/cross.png"
    class="icon"
/>

<mat-dialog-content
    [ngStyle.xs]="{
        maxHeight: '55vh',
        marginBottom: '20px',
        minHeight: '50vh'
    }"
>
    <div style="width: 100%; height: 100%">
        <picture>
            <iframe
                width="760"
                class="video"
                height="515"
                allow="autoplay; fullscreen"
                [src]="
                    'https://www.youtube.com/embed/' +
                        videoId +
                        '?rel=0&autoplay=1&autopause=0&mute=1&loop=1&controls=0&enablejsapi=1&iv_load_policy=3&fs=0&cc_load_policy=0' +
                        '&modestbranding=1&showinfo=0' | pipesafe
                "
                frameborder="0"
                allowfullscreen
            >
            </iframe>
        </picture>
    </div>
</mat-dialog-content>
